import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import { useState } from 'react'
import { useEffect } from 'react'
import usAreaCodes from 'utils/usAreaCodes'

import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import styles from './SearchRow.module.scss'

const SearchRow = ({ handleSearch, loading, reservationHotline, stateCode }) => {
  const match = reservationHotline.match(/^\+1([0-9]{3})/)

  const defaultAreaCode = match ? match[1] : ''

  const [areaCode, setAreaCode] = useState(defaultAreaCode)
  const [numberPattern, setNumberPattern] = useState('')
  const [submitDisabled, setSubmitDisabled] = useState(true)

  useEffect(() => {
    if (!loading && areaCode.length === 3 && numberPattern.replace(/\D/, '').length > 2) {
      setSubmitDisabled(false)
    } else {
      setSubmitDisabled(true)
    }
  }, [areaCode.length, loading, numberPattern])

  function cleanUpNumber(number) {
    return number
      .toLowerCase()
      .trim()
      .replace(/[^0-9|*]+$/g, '')
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (!submitDisabled) {
      handleSearch(areaCode, numberPattern)
    }
  }

  const stateAreaCodes = usAreaCodes[stateCode]

  const [showAreaCodeDropdown, setShowAreaCodeDropdown] = useState(stateAreaCodes)

  function handleAreaCodeDropdownChange(e) {
    if (e.target.value === 'Other') {
      setShowAreaCodeDropdown(false)
    } else {
      setAreaCode(e.target.value)
    }
  }

  return (
    <form className={styles.container} onSubmit={handleSubmit}>
      {showAreaCodeDropdown ? (
        <Dropdown
          label="Area code"
          value={areaCode}
          onChange={handleAreaCodeDropdownChange}
          options={[...usAreaCodes[stateCode], 'Other'].reduce(
            (prev, curr) => ({ ...prev, [curr]: curr }),
            {}
          )}
        />
      ) : (
        <TextInput
          value={areaCode}
          onChange={e => setAreaCode(cleanUpNumber(e.target.value))}
          label="Area code"
          maxLength={3}
          style={{ width: 100 }}
        />
      )}
      <TextInput
        value={numberPattern}
        onChange={e => setNumberPattern(cleanUpNumber(e.target.value))}
        label="Number pattern"
        width={220}
      />
      <button disabled={submitDisabled} className={styles.primaryButton}>
        {loading ? 'Loading' : 'Search'}
      </button>
      <span>
        <strong>Number pattern needs to have at least 3 digits.</strong> In phone number
        searches you can use the wildcard function when you put an asterisk symbol
        (&quot;*&quot;) in the place of a number.
      </span>
    </form>
  )
}
export default SearchRow
